/*const AVLabGame = () => {
return (
    <div style={{ 
      width: '100vw', 
      height: '99.9%',
      margin: 0,
      padding: 0,
    }}>
      <iframe
        src="/signal-av-lab/signal-av-lab-sim.html"
        width="100%"
        height="100%"
        frameBorder="0"
        title="SIGNAL AV Lab"
        style={{ 
          display: 'block', 
          margin: 0, 
          padding: 0,
        }}
      />
    </div>
)
}
export default AVLabGame;*/

/**fixed viewport possible */
import classes from "./AVLabGame.module.css";

const AVLabGame = () => {
return (
    /*<div style={{ 
      width: '100vw',
      height: '99.6%',
      margin: 0,
      padding: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
    }}>*/
    <div className={classes.pageWrapper}>
      <div className={classes.iframeContainer}> 
        <iframe
          src="/signal-av-lab/signal-av-lab-sim.html"
          width="100%"
          height="93.5%"
          frameBorder="0"
          title="SIGNAL AV Lab"
          /*style={{ 
            position: 'absolute',
            width: '100%',
            height: '100%',
            display: 'block',
            margin: 0,
            padding: 0,
          }}*/
        />
      </div>
    </div>
)
}
export default AVLabGame;


/*import { useEffect, useRef } from 'react';

const AVLabGame = () => {
  const contentRef = useRef(null);

  useEffect(() => {
    const updatePadding = () => {
      if (!contentRef.current) return;
      
      const aspectRatio = 16 / 9;
      const windowRatio = window.innerWidth / window.innerHeight;
      
      if (windowRatio > aspectRatio) {
        const extraSpace = window.innerWidth - (window.innerHeight * aspectRatio);
        const paddingValue = extraSpace / 2;
        contentRef.current.style.padding = `0 ${paddingValue}px`;
      } else {
        contentRef.current.style.padding = '0';
      }
    };

    // Initial update
    updatePadding();

    // Update on window resize with debounce
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updatePadding, 100);
    };
    window.addEventListener('resize', handleResize);

    // ResizeObserver setup
    const resizeObserver = new ResizeObserver(() => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updatePadding, 100);
    });
    resizeObserver.observe(document.body);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      resizeObserver.disconnect();
      clearTimeout(resizeTimeout);
    };
  }, []); // Empty dependency array means this runs once on mount

  return (
    <div style={{ 
      width: '100vw',
      height: '99.6%',
      margin: 0,
      padding: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden'
    }}>
      <div 
        ref={contentRef}
        style={{
          width: '99%',
          maxHeight: '100%',
          maxWidth: '100%',
          position: 'relative',
          aspectRatio: '16/9',
        }}>
        <iframe
          src="/signal-av-lab/signal-av-lab-sim.html"
          width="100%"
          height="100%"
          frameBorder="0"
          title="SIGNAL AV Lab"
          style={{ 
            position: 'absolute',
            width: '100%',
            height: '100%',
            display: 'block',
            margin: 0,
            padding: 0,
          }}
        />
      </div>
    </div>
  );
};

export default AVLabGame;*/
